import script from "./Subordinate.vue?vue&type=script&setup=true&lang=ts"
export * from "./Subordinate.vue?vue&type=script&setup=true&lang=ts"

import "./Subordinate.vue?vue&type=style&index=0&id=2f6728db&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f6728db"]])

export default __exports__